/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ComparisonsControllerListChangesQueryResponse, ComparisonsControllerListChangesPathParams, ComparisonsControllerListChangesQueryParams, ComparisonsControllerListChanges401, ComparisonsControllerListChanges403 } from "../../models/comparisonsController/ComparisonsControllerListChanges";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { comparisonsControllerListChanges } from "../../clients/comparisonsService/comparisonsControllerListChanges";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const comparisonsControllerListChangesQueryKey = (id: ComparisonsControllerListChangesPathParams["id"], params: ComparisonsControllerListChangesQueryParams = {}) => [{
  url: '/api/v1/comparisons/:id/changes',
  params: {
    id: id
  }
}, ...(params ? [params] : [])] as const;
export type ComparisonsControllerListChangesQueryKey = ReturnType<typeof comparisonsControllerListChangesQueryKey>;
export function comparisonsControllerListChangesQueryOptions(id: ComparisonsControllerListChangesPathParams["id"], params?: ComparisonsControllerListChangesQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = comparisonsControllerListChangesQueryKey(id, params);
  return queryOptions<ComparisonsControllerListChangesQueryResponse, ResponseErrorConfig<ComparisonsControllerListChanges401 | ComparisonsControllerListChanges403>, ComparisonsControllerListChangesQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return comparisonsControllerListChanges(id, params, config);
    }
  });
}

/**
 * @description Returns a paginated list of changes for the given comparison. Supports filtering via filter[changeType]=EDIT and full-text search via search=term (searches analysisTitle and analysis). Sort via sort=orderIndex or sort=-orderIndex. Paginate via page[number]=1&page[size]=20. Meta includes standard pagination fields plus reviewedCount (assessed changes across the full comparison).
 * @summary List changes for a comparison
 * {@link /api/v1/comparisons/:id/changes}
 */
export function useComparisonsControllerListChanges<TData = ComparisonsControllerListChangesQueryResponse, TQueryData = ComparisonsControllerListChangesQueryResponse, TQueryKey extends QueryKey = ComparisonsControllerListChangesQueryKey>(id: ComparisonsControllerListChangesPathParams["id"], params?: ComparisonsControllerListChangesQueryParams, options: {
  query?: Partial<QueryObserverOptions<ComparisonsControllerListChangesQueryResponse, ResponseErrorConfig<ComparisonsControllerListChanges401 | ComparisonsControllerListChanges403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? comparisonsControllerListChangesQueryKey(id, params);
  const query = useQuery({
    ...comparisonsControllerListChangesQueryOptions(id, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ComparisonsControllerListChanges401 | ComparisonsControllerListChanges403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}